/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Private_Models_Connection_ImportInputs */



/**
* | output |
* | --- |
* | "Add models ({count})" |
*
* @param {Private_Models_Connection_ImportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_import = /** @type {((inputs: Private_Models_Connection_ImportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_ImportInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Modelle hinzufügen (${i?.count})`)
	return /** @type {LocalizedString} */ (`Add models (${i?.count})`)
});